var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"dropzoneBox",staticClass:"dropzone-box"},[(_vm.showDialogElement)?_c('div',{staticClass:"open-dialog",on:{"click":_vm.openDialog}}):_vm._e(),_c('div',{ref:"dropzoneContainer",staticClass:"dropzone"})])
}
var staticRenderFns = []

export { render, staticRenderFns }